document.addEventListener('DOMContentLoaded', function() {
  const scrollAnimationModels = document.querySelectorAll('model-viewer[data-scroll-animation="true"]');
  const scrollRotationModels = document.querySelectorAll('model-viewer[data-scroll-rotation="true"]');
  const allModels = document.querySelectorAll('model-viewer');
  
  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateModelsOnScroll() {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;
    
    scrollRotationModels.forEach((model, index) => {
      try {
        const currentOrbit = model.getCameraOrbit();
        const scrollSensitivity = parseFloat(model.dataset.scrollSensitivity || 0.5);
        const isReverse = model.dataset.scrollDirection === 'reverse';
        
        let rotationSpeed = scrollDelta * scrollSensitivity;
        if (isReverse) rotationSpeed *= -1;
        
        const newAzimuth = currentOrbit.theta + (rotationSpeed * Math.PI / 180);
        model.cameraOrbit = `${newAzimuth}rad ${currentOrbit.phi}rad ${currentOrbit.radius}m`;
      } catch (error) {
        console.log('Model rotation update skipped for model:', index);
      }
    });
    
    lastScrollY = currentScrollY;
    ticking = false;
  }

  function requestTick() {
    if (!ticking && scrollRotationModels.length > 0) {
      requestAnimationFrame(updateModelsOnScroll);
      ticking = true;
    }
  }

  if (scrollRotationModels.length > 0) {
    window.addEventListener('scroll', requestTick, { passive: true });
  }

  if (scrollAnimationModels.length > 0) {
    const observerOptions = {
      threshold: 0.3,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const modelViewer = entry.target;
        if (entry.isIntersecting) {
          if (modelViewer.animationName) {
            modelViewer.play();
          }
        } else {
          if (modelViewer.animationName) {
            modelViewer.pause();
          }
        }
      });
    }, observerOptions);

    scrollAnimationModels.forEach(model => {
      observer.observe(model);
    });
  }

  allModels.forEach((model, index) => {
    model.addEventListener('load', function() {
      const loadingIndicator = this.parentElement.querySelector('.loading');
      if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
      }
    });

    model.addEventListener('error', function() {
      const loadingIndicator = this.parentElement.querySelector('.loading');
      if (loadingIndicator) {
        loadingIndicator.textContent = 'Failed to load 3D model';
        loadingIndicator.style.color = '#ff4444';
      }
    });
  });
});
